import Lottie from 'lottie-react';
import {PaddingBox} from '@/styled-components';
import SkeltonLottie from './assets/skelton.json';
import {BlueInfoText, ScrollBody} from './StyledComponents';
import {AiSubHeader} from './SubHeader';

export const LoadingPrompt = () => {
  return (
    <>
      <AiSubHeader>
        <BlueInfoText>해당 지역 데이터를 읽고 있어요</BlueInfoText>
      </AiSubHeader>
      <ScrollBody>
        <PaddingBox top={4}>
          <Lottie animationData={SkeltonLottie} />
        </PaddingBox>
      </ScrollBody>
    </>
  );
};
